export default __webpack_public_path__ + "static/media/type.6eb34930.svg";